import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';

interface LinkProdutoProps {
    produtoId: number | string;
    children: React.ReactNode;
    className?: string;
    showIcon?: boolean;
}

const LinkProduto: React.FC<LinkProdutoProps> = ({
    produtoId,
    children,
    className = "",
    showIcon = true
}) => {
    const handleClick = (e: React.MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        window.open(`/cadastros/produtos/${produtoId}`, '_blank');
    };

    return (
        <a
            href={`/cadastros/produtos/${produtoId}`}
            onClick={handleClick}
            className={`text-decoration-none ${className}`}
            title="Abrir cadastro do produto"
            style={{ cursor: 'pointer' }}
        >
            {children}
            {showIcon && (
                <FontAwesomeIcon
                    icon={faExternalLinkAlt}
                    className="ms-1"
                    size="sm"
                />
            )}
        </a>
    );
};

export default LinkProduto; 